'use client';

import '@ui5/webcomponents/dist/TableCell.js';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `TableCell` component defines the structure of the data in a single `Table` cell.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/Table" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const TableCell = withWebComponent('ui5-table-cell', [], [], [], []);
TableCell.displayName = 'TableCell';
export { TableCell };